import { applyMiddleware, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { connect } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";

import createRootReducer, { IApplicationState } from "./Reducers";

// Store setup predates Redux Toolkit's configureStore and stays on createStore + thunk +
// connected-react-router (the router requires this shared `history` instance : the same one the
// Router component mounts). Slices themselves are RTK createSlice; only the wiring is classic.

export const history = createBrowserHistory();

export const store = configureStore();

/**
 * connect() wrapper kept for the remaining class/legacy components: binds a state selector and an
 * action-creators map in one call. New code uses useSelector/useDispatch directly.
 */
export function withStore<
    TStoreState,
    TActionCreators,
    TComponent extends React.ComponentType<TStoreState & TActionCreators & any>
>(component: TComponent, stateSelector: (state: IApplicationState) => TStoreState, actionCreators: TActionCreators) {
    return connect(stateSelector, actionCreators)(component);
}

function configureStore() {
    const store = createStore(
        createRootReducer(history),
        composeWithDevTools(applyMiddleware(thunk, routerMiddleware(history)))
    );

    return store;
}
